/**
 * TimePicker Types
 *
 * Type definitions for the TimePicker component
 */

export interface TimePickerProps {
  /** Time value in "HH:mm" 24-hour format */
  value: string;

  /** Callback when time changes */
  onChange: (time: string) => void;

  /** Disable the picker */
  disabled?: boolean;

  /** Display timezone name (e.g., "Europe/Berlin") */
  timezone?: string;

  /** Timezone abbreviation (e.g., "CET", "CEST") */
  timezoneAbbreviation?: string;

  /** Selected date for past-time validation */
  selectedDate?: Date;

  /** Allow selecting times in the past (default: false) */
  allowPast?: boolean;

  /** Additional CSS classes */
  className?: string;
}

export interface QuickTimeGridProps {
  /** Currently selected time in "HH:mm" format */
  selectedTime: string;

  /** Callback when a time is selected */
  onTimeSelect: (time: string) => void;

  /** Selected date for past-time validation */
  selectedDate?: Date;

  /** Account timezone used to decide whether a quick time has passed. */
  timezone?: string;

  /** Allow selecting times in the past */
  allowPast?: boolean;

  /** Disable all time selections */
  disabled?: boolean;
}

export interface TimeWheelSelectorProps {
  /** Currently selected time in "HH:mm" format */
  selectedTime: string;

  /** Callback when time changes */
  onTimeChange: (time: string) => void;

  /** Disable the selector */
  disabled?: boolean;
}

/** Predefined quick-select times */
export const QUICK_SELECT_TIMES = [
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '12:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
] as const;
